import { BlockCard } from "src/modules/worksheet/components/WorksheetEditor/components/Editor";

const renderCardMCQ = (props: any, isMCQ = true) => {
    const {
        block: {
            data: {
                mcq: { text },
            },
        },
    } = props;
    const tmp = text.find(({ type, children }: any) => type == "p")?.children[0]
        .text;
    const displayText = tmp
        ? tmp.slice(0, tmp.length > 10 ? 10 : tmp.length)
        : "...";
    return (
        <BlockCard {...props}>
            <div>{displayText}</div>
            <div style={{ fontSize: "11px", fontWeight: "bold" }}>
                {isMCQ ? "MCQ Block" : "Reordering Question Block"}
            </div>
        </BlockCard>
    );
};

export default renderCardMCQ;
